import { supabase } from '@/integrations/supabase/client'

export async function createSampleLeague() {
  try {
    // Get current user
    const { data: { user } } = await supabase.auth.getUser()
    if (!user) throw new Error('User not authenticated')

    // Create sample league
    const { data: league, error: leagueError } = await supabase
      .from('leagues')
      .insert({
        name: 'Premier League Draft Test',
        owner_id: user.id,
        is_private: false,
        starters_count: 11,
        bench_count: 10,
        draft_at: new Date(Date.now() + 60 * 60 * 1000).toISOString() // 1 hour from now
      })
      .select()
      .single()

    if (leagueError) throw leagueError

    // Create sample gameweeks
    const gameweeks = []
    for (let i = 1; i <= 5; i++) {
      gameweeks.push({
        league_id: league.id,
        gw_number: i,
        lock_at: new Date(Date.now() + i * 24 * 60 * 60 * 1000).toISOString(), // i days from now
        status: 'upcoming' as const
      })
    }

    const { error: gameweeksError } = await supabase
      .from('gameweeks')
      .insert(gameweeks)

    if (gameweeksError) throw gameweeksError

  const { data, error } = await supabase
    .from('league_players')
    .insert({
      league_id: league.id,
      user_id: user.id
    })
    .select()
    .single()

    if (error) throw error

    return { league, player: data }
  } catch (error) {
    console.error('Error creating sample league:', error)
    throw error
  }
}